import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.Codigo && (path = `${path !== '' ? `${path}&` : ''}Codigo=${params.Codigo}`);
  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  params.CodigoDeposito &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoDeposito=${params.CodigoDeposito}`);
  params.Clave && (path = `${path !== '' ? `${path}&` : ''}Clave=${params.Clave}`);
  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);

  return path;
};
